import { BFLType, ModuleTypeId } from "../../types/DBTables";
import { IGlobalData } from "../../types/globalData";
import { IBIMHandler } from "./bimHandler";
import { IModuleRound, IRoundHandler } from "../roundHandler";

import bflHelper from "./bflHelper";
import { IBFModule, IBFResult, IKontrollResultRow, IKontrollResultRowDriftoptimering } from "../../types/BFL/Funktionskontroll";
import { logAndNotifyError } from "../logger";
import { IModuleByggnadsdata, IModuleLokaler, IModuleVentilationFTXochFT } from "../../types/ModuleDatas";
import { sumSchedule } from "../TimePeriods";
import { VeckoSchemaPerioder } from "../../types/module-type";
import { IJ5_FTX_FT_BFData } from "../../types/BFDatas";

//todo -> make class?!
export const bfl_J5_FTX_FT = (): IBFModule => {
  const bfName = BFLType.BFL_J5_FTX_FT;
  const getResult = (module: IModuleRound, bimHandler: IBIMHandler, roundHandler: IRoundHandler, globalData: IGlobalData, formData: any): IBFResult => {
    //const moduleData: IModuleVattenburetSekundärsystem = module.data;

    let funktionsKontroller: IKontrollResultRow[] = [];
    let driftOptimeringar: IKontrollResultRowDriftoptimering[] = [];
    let data = { export: {} } as IJ5_FTX_FT_BFData;
    let debug = {} as any;
    let error: any = undefined;

    const bH = bflHelper.bflHelper();

    try {
      formData = (formData?.data || module.bfs.BFL_J5_FTX_FT?.data) as IJ5_FTX_FT_BFData | undefined;

      debug["BIM"] = {
        BIM_DensitetLuft: bimHandler.BIM_DensitetLuft,
        BIM_Luft_Energimängd: bimHandler.BIM_Luft_Energimängd,
        BIM_GradtimmarVärmeFörOrten: bimHandler.BIM_GradtimmarVärmeFörOrten,
        BIM_Gradtimmar_Kyla_Orten: bimHandler.BIM_Gradtimmar_Kyla_Orten,
        BIM_TimmarPerGrad_Värme: bimHandler.BIM_TimmarPerGrad_Värme,
        normalårsTemperatur: bimHandler.normalårsTemperatur,
        normalårsTemperaturOmråde: bimHandler.normalårsTemperaturOmråde,
      };

      const isSummer = roundHandler.getActiveRound()?.isSummer as boolean;

      //Moduledata
      const moduleData = module.data as IModuleVentilationFTXochFT;
      const byggnadsModule = roundHandler.getRoundData()?.data.modules.find((m) => m.moduleTypeId === ModuleTypeId.Byggnadsdata);
      const byggnadModuleData = byggnadsModule?.data as IModuleByggnadsdata;
      const lokalerModule = roundHandler.getRoundData()?.data.modules.find((m) => m.moduleTypeId === ModuleTypeId.Lokaler);
      const lokalerModuleData = lokalerModule?.data as IModuleLokaler;

      const flödeEnhetFT = moduleData.flödeEnhet;
      const enhetKubikmeterPerTimme = "Kubikmeter per timme (m³/h)";
      const flödeTillluftFT = moduleData.flödeTilluft ? moduleData.flödeTilluft : 0;
      const flödeFrånluftFT = moduleData.flödeFrånluft ? moduleData.flödeFrånluft : 0;
      const flödeKanalstorlekBxH = moduleData.flödeKanalstorlekBxH;
      const flödeFrånluftDiameter = moduleData.flödeFrånluftDiameter ? moduleData.flödeFrånluftDiameter : 0;
      const reduceratFlödeRumsdonFasta = moduleData.harReduceradeLuftflödeFastaRumsdon === "Ja" && moduleData.reduceratFlödeRumsdonFasta ? moduleData.reduceratFlödeRumsdonFasta : 0;
      const reduceratFlödeRumsdonReglerbara =
        moduleData.harReduceradeLuftflödeReglerbaraRumsdon === "Ja" && moduleData.reduceratFlödeRumsdonReglerbara ? moduleData.reduceratFlödeRumsdonReglerbara : 0;
      const kylbatteriSystemtyp = moduleData.kylbatteri;
      const eftervärmningsbatteri = moduleData.eftervärmningsbatteri;
      const kylÅtervinningAktiv = moduleData.kylÅtervinningAktiv;
      const harBefuktning = moduleData.harBefuktning;
      const harAvfuktare = moduleData.harLufttork;

      const driftÅretRunt = moduleData.driftÅretRunt === "Ja";
      const delfartsFaktor = moduleData.delfartsFaktor ? moduleData.delfartsFaktor / 100 : 0;

      const timmarHelår = 24 * 365;
      const timmarVecka = 24 * 7;
      const veckorPerÅr = timmarHelår / timmarVecka;

      let minuterHelfart = 0;
      let minuterDelfart = 0;
      if (driftÅretRunt) {
        const minuterPerVecka = (timmarHelår * 60) / veckorPerÅr; //8760 timmar * 60 minuter / veckor per år
        minuterHelfart = minuterPerVecka * (1 - delfartsFaktor);
        minuterDelfart = minuterPerVecka * delfartsFaktor;
      } else {
        minuterDelfart = moduleData.tidsKanaler ? sumSchedule(moduleData.tidsKanaler.ventilation as VeckoSchemaPerioder, "Delfart") : 0;
        minuterHelfart = moduleData.tidsKanaler ? sumSchedule(moduleData.tidsKanaler.ventilation as VeckoSchemaPerioder, "Helfart") : 0;
      }

      const kylaSaknas = kylbatteriSystemtyp === "Kyla saknas";
      const kylform = kylbatteriSystemtyp === "Central vattenburen kyla" ? moduleData.kylform : kylbatteriSystemtyp;

      const vägledandeVerkningsgradVärme = bimHandler.getVerkningsgradFromVärmeBatterityp(eftervärmningsbatteri); //globalData.Ventilation.VärmebatteriTyp.find((s) => s.VärmebatteriTyp === eftervärmningsbatteri)?.VägledandeVerkningsgrad as number;
      const vägledandeVerkningsgradKyla = globalData.Ventilation.Kylform.find((s) => s.Kylform === kylform)?.Verkningsgrad as number;

      //base data
      const ftxj5SystemtypVentilation = module.moduleTypeId.toString();
      const ftxj5SystemtypÅtervinning = moduleData.systemtypÅtervinningFTX;

      const ftxj5tempUteluft = moduleData.tempUteluft;
      const ftxj5tempTillLuftEfterÅtervinningsBat = moduleData?.tempTillLuftEfterÅtervinningsBat;
      const ftxj5tempTillLuftEfterEftervärmningssBat = moduleData.tempTillLuftEfterEftervärmningssBat;
      const ftxj5tempTillLuftEfterEfterkylningssBat = moduleData.tempTillLuftEfterEfterkylningssBat;
      const ftxj5tempFrånLuftInnanÅtervinningsBat = moduleData.tempFrånLuftInnanÅtervinningsBat;
      const ftxj5tempAvluftInnanVentilationsAgg = moduleData.tempAvluftInnanVentilationsAgg;
      const ftxj5börvärdeRegTilluft = moduleData.börvärdeRegTilluft;
      const ftxj5ärvärdeRegTilluft = moduleData.ärvärdeRegTilluft;
      const ftxj5kontrollmättTempRegTilluft = moduleData.kontrollmättTempRegTilluft;

      const ftxj5utstyrningVärmeåtervinning = ((moduleData.utstyrningVärmeåtervinning ? moduleData.utstyrningVärmeåtervinning : 0) / 100) as number;
      const ftxj5utstyrningEftervärmning = ((moduleData.utstyrningEftervärmning ? moduleData.utstyrningEftervärmning : 0) / 100) as number;
      const ftxj5utstyrningEfterkylning = ((moduleData.utstyrningEfterkylning ? moduleData.utstyrningEfterkylning : 0) / 100) as number;

      const isFTX = module.moduleTypeId === ModuleTypeId.VentilationFTX;

      //=IF(AND(flödeTillluftFT+flödeFrånluftFT<1;flödeKanalstorlekBxH_FT>1);"Schablonvärde";"Verifierad mätning")
      const ftxj5LuftflödeRektangulär = flödeTillluftFT + flödeFrånluftFT < 1 && flödeKanalstorlekBxH !== "" ? "Schablonvärde" : "Verifierad mätning";
      //=IF(AND(flödeTillluftFT+flödeFrånluftFT<1;flödeFrånluftDiameter>1);"Schablonvärde";'Grunddata IN'!BN16)
      const ftxj5LuftflödeCirkulär = flödeTillluftFT + flödeFrånluftFT < 1 && flödeFrånluftDiameter ? "Schablonvärde" : "Verifierad mätning";

      //=IF(ftxj5LuftflödeRektangulär="Schablonvärde";VLOOKUP(flödeKanalstorlekBxH_FT;'Grunddata IN'!BP12:BR70;3;FALSE);0)
      const ftxj5LpSRektangulär =
        ftxj5LuftflödeRektangulär === "Schablonvärde" ? (globalData.Ventilation.KanalstorlekRektangulära.find((x) => x.KanalstorlekRektangulära === flödeKanalstorlekBxH)?.LiterPerSekund ?? 0) : 0;
      //=IF(ftxj5LuftflödeCirkulär="Schablonvärde";VLOOKUP(flödeFrånluftDiameter;'Grunddata IN'!BS12:BU25;3;FALSE);0)
      const ftxj5LpSCirkulär =
        ftxj5LuftflödeCirkulär === "Schablonvärde" ? (globalData.Ventilation.KanalstorlekCirkulära.find((x) => x.KanalstorlekCirkulära === Number(flödeFrånluftDiameter))?.LiterPerSekund ?? 0) : 0;

      const ftxj5FörväntadTemperatursverkningsgradÅtervinning = globalData.Ventilation.SystemtypÅtervinning.find((s) => s.SystemtypÅtervinning === ftxj5SystemtypÅtervinning)
        ?.FörväntadTemperaturverkningsgrad as number;

      //=(ftxj5tempTillLuftEfterÅtervinningsBat-ftxj5tempUteluft)/(ftxj5tempFrånLuftInnanÅtervinningsBat-ftxj5tempUteluft)
      const ftxj5UppmättTemperatursverkningsgradÅtervinning =
        ftxj5tempFrånLuftInnanÅtervinningsBat - ftxj5tempUteluft === 0
          ? 0
          : ftxj5FörväntadTemperatursverkningsgradÅtervinning
            ? (ftxj5tempTillLuftEfterÅtervinningsBat - ftxj5tempUteluft) / (ftxj5tempFrånLuftInnanÅtervinningsBat - ftxj5tempUteluft)
            : 0;

      //=IF(flödeEnhetFT=enhetKubikmeterPerTimme;MAX(flödeTillluftFT;ftxj5LpSRektangulär;ftxj5LpSCirkulär)/3,6;MAX(flödeTillluftFT;ftxj5LpSRektangulär;ftxj5LpSCirkulär))
      const ftxj5FlödeTilluftHelfart =
        flödeEnhetFT === enhetKubikmeterPerTimme ? Math.max(flödeTillluftFT, ftxj5LpSRektangulär, ftxj5LpSCirkulär) / 3.6 : Math.max(flödeTillluftFT, ftxj5LpSRektangulär, ftxj5LpSCirkulär);

      const ftxj5VentialtionsaggregatReduceradDrift = minuterDelfart > 0 ? "Ja" : "Nej";
      //=IF(ftxj5VentialtionsaggregatReduceradDrift="Ja";MAX(reduceratFlödeRumsdonFasta;reduceratFlödeRumsdonReglerbara);0)
      const ftxj5FlödeTilluftReduceradDrift = ftxj5VentialtionsaggregatReduceradDrift === "Ja" ? Math.max(reduceratFlödeRumsdonFasta, reduceratFlödeRumsdonReglerbara) / 100 : 0;

      const ftxj5MotoreffektTilluft = moduleData.motoreffektTilluft;
      const ftxj5MotoreffektFrånluft = moduleData.motoreffektFrånluft;

      const ftxj5DrifttidHelfartTimmarPerÅr = ((veckorPerÅr - moduleData.antalVeckorVentilationStoppadPerÅr) * minuterHelfart) / 60;
      const ftxj5DriftfaktorHelfartProcent = ftxj5DrifttidHelfartTimmarPerÅr >= 8760 ? 1 : ftxj5DrifttidHelfartTimmarPerÅr / 8760;

      const ftxj5DrifttidDelfartTimmarPerÅr = ((veckorPerÅr - moduleData.antalVeckorVentilationStoppadPerÅr) * minuterDelfart) / 60;
      const ftxj5DriftfaktorDelfartProcent = ftxj5DrifttidDelfartTimmarPerÅr >= 8760 ? 1 : ftxj5DrifttidDelfartTimmarPerÅr / 8760;

      //=((ftxj5FlödeTilluftHelfart/1000)*BIM_DensitetLuft*BIM_Luft_Energimängd*BIM_GradtimmarVärmeFörOrten*ftxj5DriftfaktorHelfartProcent)+(ftxj5FlödeTilluftHelfart/1000)*ftxj5FlödeTilluftReduceradDrift*BIM_DensitetLuft*BIM_Luft_Energimängd*BIM_GradtimmarVärmeFörOrten*ftxj5DriftfaktorDelfartProcent

      const ftxj5NormalEnergianvändningVärmeKwhÅr =
        (ftxj5FlödeTilluftHelfart / 1000) *
          bimHandler.BIM_DensitetLuft *
          bimHandler.BIM_Luft_Energimängd *
          bimHandler.BIM_GradtimmarVärmeFörOrten *
          ftxj5DriftfaktorHelfartProcent *
          ftxj5FörväntadTemperatursverkningsgradÅtervinning +
        (ftxj5FlödeTilluftHelfart / 1000) *
          ftxj5FlödeTilluftReduceradDrift *
          bimHandler.BIM_DensitetLuft *
          bimHandler.BIM_Luft_Energimängd *
          bimHandler.BIM_GradtimmarVärmeFörOrten *
          ftxj5DriftfaktorDelfartProcent *
          ftxj5FörväntadTemperatursverkningsgradÅtervinning;

      //=IF(kylbatteriSystemtyp="Kyla saknas";0;((ftxj5FlödeTilluftHelfart/1000)*BIM_DensitetLuft*BIM_Luft_Energimängd*BIM_Gradtimmar_Kyla_Orten*ftxj5DriftfaktorHelfartProcent)+((ftxj5FlödeTilluftHelfart/1000)*BIM_DensitetLuft*BIM_Luft_Energimängd*BIM_Gradtimmar_Kyla_Orten*ftxj5DriftfaktorDelfartProcent))
      const ftxj5NormalEnergianvändningKylaKwhÅr =
        kylbatteriSystemtyp === "Kyla saknas"
          ? 0
          : (ftxj5FlödeTilluftHelfart / 1000) * bimHandler.BIM_DensitetLuft * bimHandler.BIM_Luft_Energimängd * bimHandler.BIM_Gradtimmar_Kyla_Orten * ftxj5DriftfaktorHelfartProcent +
            (ftxj5FlödeTilluftHelfart / 1000) * bimHandler.BIM_DensitetLuft * bimHandler.BIM_Luft_Energimängd * bimHandler.BIM_Gradtimmar_Kyla_Orten * ftxj5DriftfaktorDelfartProcent;

      //=(ftxj5börvärdeRegTilluft-BIM_NormalårsTemperatur)*BIM_TimmarPerGrad_Värme
      const ftxj5GradtimmarVärmeFörOrten = (ftxj5börvärdeRegTilluft - bimHandler.normalårsTemperatur) * bimHandler.BIM_TimmarPerGrad_Värme;
      const bimNormalårstemperatur = bimHandler.normalårsTemperaturOmråde;

      const GetGradtimmarKyla = (sökVärde: number) => {
        let tempTilluft = Math.min(20, sökVärde);
        tempTilluft = Math.max(15, tempTilluft);
        tempTilluft = Math.floor(tempTilluft);

        const gradtimmarRow = globalData.Gemensamt.gradtimmarKylaPerTabellområdeOchTempTilluft.find((r) => r.Tabellområde === bimNormalårstemperatur && r.TempTilluft === tempTilluft);

        const remainder = sökVärde - tempTilluft;
        const gradtimmarKyla = gradtimmarRow?.GradtimmarKyla as number;
        const intervall = gradtimmarRow?.Intervall as number;
        const offset = intervall * -remainder;
        const totaltGradtimmarKyla = gradtimmarKyla + offset;

        return totaltGradtimmarKyla as number;
      };

      const gradtimmarKylaTabell1 = GetGradtimmarKyla(ftxj5ärvärdeRegTilluft);
      const gradtimmarKylaTabell2 = GetGradtimmarKyla(ftxj5börvärdeRegTilluft);

      const ftxj5GradtimmarKylaFörOrten = gradtimmarKylaTabell2;

      //=((ftxj5FlödeTilluftHelfart/1000)*BIM_DensitetLuft*BIM_Luft_Energimängd*ftxj5GradtimmarVärmeFörOrten*(1-ftxj5UppmättTemperatursverkningsgradÅtervinning)*ftxj5DriftfaktorHelfartProcent)+(ftxj5FlödeTilluftHelfart/1000)*ftxj5FlödeTilluftReduceradDrift*BIM_DensitetLuft*BIM_Luft_Energimängd*ftxj5GradtimmarVärmeFörOrten*(1-ftxj5UppmättTemperatursverkningsgradÅtervinning)*ftxj5DriftfaktorDelfartProcent
      const ftxj5EnergianvändningUppvärmningÅr =
        (ftxj5FlödeTilluftHelfart / 1000) *
          bimHandler.BIM_DensitetLuft *
          bimHandler.BIM_Luft_Energimängd *
          ftxj5GradtimmarVärmeFörOrten *
          (1 - ftxj5UppmättTemperatursverkningsgradÅtervinning) *
          ftxj5DriftfaktorHelfartProcent +
        (ftxj5FlödeTilluftHelfart / 1000) *
          ftxj5FlödeTilluftReduceradDrift *
          bimHandler.BIM_DensitetLuft *
          bimHandler.BIM_Luft_Energimängd *
          ftxj5GradtimmarVärmeFörOrten *
          (1 - ftxj5UppmättTemperatursverkningsgradÅtervinning) *
          ftxj5DriftfaktorDelfartProcent;

      //=IF(kylbatteriSystemtyp="Kyla saknas";0;((ftxj5FlödeTilluftHelfart/1000)*BIM_DensitetLuft*BIM_Luft_Energimängd*ftxj5GradtimmarKylaFörOrten*ftxj5DriftfaktorHelfartProcent)+((ftxj5FlödeTilluftHelfart/1000)*BIM_DensitetLuft*BIM_Luft_Energimängd*ftxj5GradtimmarKylaFörOrten*ftxj5DriftfaktorDelfartProcent))
      const ftxj5EnergianvändningKylaÅr =
        kylbatteriSystemtyp === "Kyla saknas"
          ? 0
          : (ftxj5FlödeTilluftHelfart / 1000) * bimHandler.BIM_DensitetLuft * bimHandler.BIM_Luft_Energimängd * ftxj5GradtimmarKylaFörOrten * ftxj5DriftfaktorHelfartProcent +
            (ftxj5FlödeTilluftHelfart / 1000) * bimHandler.BIM_DensitetLuft * bimHandler.BIM_Luft_Energimängd * ftxj5GradtimmarKylaFörOrten * ftxj5DriftfaktorDelfartProcent;

      let motorEffekt = 0;
      switch (moduleData.motoreffektUppgift) {
        case "Uppmätt värde":
          motorEffekt = moduleData.motoreffektFrånluft + moduleData.motoreffektTilluft;
          break;
        case "Driftsättningsprotokoll":
          motorEffekt = moduleData.motoreffektFrånluft + moduleData.motoreffektTilluft;
          break;
        case "Märkskylt nominell effekt":
          motorEffekt = (moduleData.motoreffektFrånluft + moduleData.motoreffektTilluft) * 0.8;
          break;
        case "Uppgift saknas":
          const tillverkningsårRow = globalData.Ventilation.Tillverkningsår.find((r) => r.Tillverkningsår === moduleData.tillverkningsår);
          const sfp = tillverkningsårRow ? (isFTX ? tillverkningsårRow.SFP_FTX : tillverkningsårRow.SFP_FT) : 0;
          motorEffekt = sfp * (ftxj5FlödeTilluftHelfart / 1000);

          break;
        default:
          throw new Error("Okänt val motoreffektUppgift: " + moduleData.motoreffektUppgift);
      }

      //=(motorEffekt*ftxj5DrifttidDelfartTimmarPerÅr*0,5)+(motorEffekt*ftxj5DrifttidHelfartTimmarPerÅr)
      const ftxj5EnergianvändningDriftelÅr = motorEffekt * ftxj5DrifttidDelfartTimmarPerÅr * 0.5 + motorEffekt * ftxj5DrifttidHelfartTimmarPerÅr;

      //=IF(B57="Central vattenburen värme";ftxj5EnergianvändningUppvärmningÅr;0)
      const ftxj5EnergianvändningCentralUppvärmningÅr = eftervärmningsbatteri === "Central vattenburen värme" ? ftxj5EnergianvändningUppvärmningÅr : 0;

      debug["Input"] = {
        ftxj5SystemtypVentilation,
        ftxj5SystemtypÅtervinning,
        ftxj5tempUteluft,
        ftxj5tempTillLuftEfterÅtervinningsBat,
        ftxj5tempTillLuftEfterEftervärmningssBat,
        ftxj5tempTillLuftEfterEfterkylningssBat,
        ftxj5tempFrånLuftInnanÅtervinningsBat,
        ftxj5tempAvluftInnanVentilationsAgg,
        ftxj5börvärdeRegTilluft,
        ftxj5ärvärdeRegTilluft,
        ftxj5kontrollmättTempRegTilluft,
        ftxj5utstyrningVärmeåtervinning,
        ftxj5utstyrningEftervärmning,
        ftxj5utstyrningEfterkylning,
        ftxj5LuftflödeRektangulär,
        ftxj5LuftflödeCirkulär,
        ftxj5LpSRektangulär,
        ftxj5LpSCirkulär,
        ftxj5UppmättTemperatursverkningsgradÅtervinning,
        ftxj5FörväntadTemperatursverkningsgradÅtervinning,
        ftxj5FlödeTilluftHelfart,
        ftxj5VentialtionsaggregatReduceradDrift,
        ftxj5FlödeTilluftReduceradDrift,
        ftxj5MotoreffektTilluft,
        ftxj5MotoreffektFrånluft,
        ftxj5DrifttidHelfartTimmarPerÅr,
        ftxj5DriftfaktorHelfartProcent,
        ftxj5DrifttidDelfartTimmarPerÅr,
        ftxj5DriftfaktorDelfartProcent,
        ftxj5NormalEnergianvändningVärmeKwhÅr,
        ftxj5NormalEnergianvändningKylaKwhÅr,
        ftxj5GradtimmarVärmeFörOrten,
        ftxj5GradtimmarKylaFörOrten,
        ftxj5EnergianvändningUppvärmningÅr,
        ftxj5EnergianvändningKylaÅr,
        ftxj5EnergianvändningDriftelÅr,
        ftxj5EnergianvändningCentralUppvärmningÅr,
        motorEffekt,
      };

      //Stickprov
      const stickProvModule = lokalerModuleData.stickprov.filter((s) => s.ventilationsSystem === module.name);
      const medelMätvärdeVistelse = stickProvModule.reduce((acc, s) => acc + s.uppmättTemperatur, 0) / stickProvModule.length;
      const medelMätvärdeTilluftsdon = stickProvModule.reduce((acc, s) => acc + s.uppmättTemperaturTilluft, 0) / stickProvModule.length;
      const medelTempDiff = medelMätvärdeVistelse - medelMätvärdeTilluftsdon;

      //Energi Luftbehandling
      //=((ftxj5tempTillLuftEfterÅtervinningsBat-BIM_NormalårsTemperatur)*BIM_TimmarPerGrad_Värme)-((ftxj5tempUteluft-BIM_NormalårsTemperatur)*BIM_TimmarPerGrad_Värme)
      const ftxj5EnergiÅtervinningsbatteriGradtimmar = isFTX
        ? (ftxj5tempTillLuftEfterÅtervinningsBat - bimHandler.normalårsTemperatur) * bimHandler.BIM_TimmarPerGrad_Värme -
          (ftxj5tempUteluft - bimHandler.normalårsTemperatur) * bimHandler.BIM_TimmarPerGrad_Värme
        : 0;
      //=((ftxj5tempTillLuftEfterEftervärmningssBat-BIM_NormalårsTemperatur)*BIM_TimmarPerGrad_Värme)-((ftxj5tempTillLuftEfterÅtervinningsBat-BIM_NormalårsTemperatur)*BIM_TimmarPerGrad_Värme)
      const ftxj5EnergiEftervärmningsbatteriGradtimmar =
        (ftxj5tempTillLuftEfterEftervärmningssBat - bimHandler.normalårsTemperatur) * bimHandler.BIM_TimmarPerGrad_Värme -
        (ftxj5tempTillLuftEfterÅtervinningsBat - bimHandler.normalårsTemperatur) * bimHandler.BIM_TimmarPerGrad_Värme;
      //=((ftxj5tempTillLuftEfterEftervärmningssBat-BIM_NormalårsTemperatur)*BIM_TimmarPerGrad_Värme)-((ftxj5tempTillLuftEfterEfterkylningssBat-BIM_NormalårsTemperatur)*BIM_TimmarPerGrad_Värme)
      const ftxj5EnergiEfterkylningsbatteriGradtimmar =
        (ftxj5tempTillLuftEfterEftervärmningssBat - bimHandler.normalårsTemperatur) * bimHandler.BIM_TimmarPerGrad_Värme -
        (ftxj5tempTillLuftEfterEfterkylningssBat - bimHandler.normalårsTemperatur) * bimHandler.BIM_TimmarPerGrad_Värme;
      //=((ftxj5FlödeTilluftHelfart/1000)*BIM_DensitetLuft*BIM_Luft_Energimängd*ftxj5EnergiÅtervinningsbatteriGradtimmar*ftxj5DriftfaktorHelfartProcent)+
      //  (ftxj5FlödeTilluftHelfart/1000)*ftxj5FlödeTilluftReduceradDrift*BIM_DensitetLuft*BIM_Luft_Energimängd*ftxj5EnergiÅtervinningsbatteriGradtimmar*ftxj5DriftfaktorDelfartProcent
      const ftxj5EnergiÅtervinningsbatterikWh =
        (ftxj5FlödeTilluftHelfart / 1000) * bimHandler.BIM_DensitetLuft * bimHandler.BIM_Luft_Energimängd * ftxj5EnergiÅtervinningsbatteriGradtimmar * ftxj5DriftfaktorHelfartProcent +
        (ftxj5FlödeTilluftHelfart / 1000) *
          ftxj5FlödeTilluftReduceradDrift *
          bimHandler.BIM_DensitetLuft *
          bimHandler.BIM_Luft_Energimängd *
          ftxj5EnergiÅtervinningsbatteriGradtimmar *
          ftxj5DriftfaktorDelfartProcent;
      //=((ftxj5FlödeTilluftHelfart/1000)*BIM_DensitetLuft*BIM_Luft_Energimängd*ftxj5EnergiEftervärmningsbatteriGradtimmar*ftxj5DriftfaktorHelfartProcent)+
      //  (ftxj5FlödeTilluftHelfart/1000)*ftxj5FlödeTilluftReduceradDrift*BIM_DensitetLuft*BIM_Luft_Energimängd*ftxj5EnergiEftervärmningsbatteriGradtimmar*ftxj5DriftfaktorDelfartProcent
      const ftxj5EnergiEftervärmningsbatterikWh =
        (ftxj5FlödeTilluftHelfart / 1000) * bimHandler.BIM_DensitetLuft * bimHandler.BIM_Luft_Energimängd * ftxj5EnergiEftervärmningsbatteriGradtimmar * ftxj5DriftfaktorHelfartProcent +
        (ftxj5FlödeTilluftHelfart / 1000) *
          ftxj5FlödeTilluftReduceradDrift *
          bimHandler.BIM_DensitetLuft *
          bimHandler.BIM_Luft_Energimängd *
          ftxj5EnergiEftervärmningsbatteriGradtimmar *
          ftxj5DriftfaktorDelfartProcent;
      //=((ftxj5FlödeTilluftHelfart/1000)*BIM_DensitetLuft*BIM_Luft_Energimängd*ftxj5EnergiEfterkylningsbatteriGradtimmar*ftxj5DriftfaktorHelfartProcent)+
      //  (ftxj5FlödeTilluftHelfart/1000)*ftxj5FlödeTilluftReduceradDrift*BIM_DensitetLuft*BIM_Luft_Energimängd*ftxj5EnergiEfterkylningsbatteriGradtimmar*ftxj5DriftfaktorDelfartProcent
      const ftxj5EnergiEfterkylningsbatterikWh =
        (ftxj5FlödeTilluftHelfart / 1000) * bimHandler.BIM_DensitetLuft * bimHandler.BIM_Luft_Energimängd * ftxj5EnergiEfterkylningsbatteriGradtimmar * ftxj5DriftfaktorHelfartProcent +
        (ftxj5FlödeTilluftHelfart / 1000) *
          ftxj5FlödeTilluftReduceradDrift *
          bimHandler.BIM_DensitetLuft *
          bimHandler.BIM_Luft_Energimängd *
          ftxj5EnergiEfterkylningsbatteriGradtimmar *
          ftxj5DriftfaktorDelfartProcent;

      //Meddelandehantering
      //Vilkor meddelande 1
      const meddelande1Vilkor1 = ftxj5kontrollmättTempRegTilluft > 1;
      const meddelande1Vilkor2 = Math.abs(ftxj5kontrollmättTempRegTilluft - ftxj5ärvärdeRegTilluft) >= 1;
      const meddelande1Vilkor3 = harBefuktning === "Nej" && harAvfuktare === "Nej";
      const meddelande1Vilkor = meddelande1Vilkor1 && meddelande1Vilkor2 && meddelande1Vilkor3;

      const gradtimmarVärmeUppmätt =
        (ftxj5kontrollmättTempRegTilluft - bimHandler.normalårsTemperatur) * bimHandler.BIM_TimmarPerGrad_Värme -
        (ftxj5ärvärdeRegTilluft - bimHandler.normalårsTemperatur) * bimHandler.BIM_TimmarPerGrad_Värme;

      const gradtimmarKylaUppmätt =
        (ftxj5ärvärdeRegTilluft - bimHandler.normalårsTemperatur) * bimHandler.BIM_TimmarPerGrad_Värme -
        (ftxj5kontrollmättTempRegTilluft - bimHandler.normalårsTemperatur) * bimHandler.BIM_TimmarPerGrad_Värme;

      const meddelande1VärmeBrutto =
        (ftxj5FlödeTilluftHelfart / 1000) *
          bimHandler.BIM_DensitetLuft *
          bimHandler.BIM_Luft_Energimängd *
          gradtimmarVärmeUppmätt *
          (1 - ftxj5UppmättTemperatursverkningsgradÅtervinning) *
          ftxj5DriftfaktorHelfartProcent +
        (ftxj5FlödeTilluftHelfart / 1000) *
          ftxj5FlödeTilluftReduceradDrift *
          bimHandler.BIM_DensitetLuft *
          bimHandler.BIM_Luft_Energimängd *
          gradtimmarVärmeUppmätt *
          (1 - ftxj5UppmättTemperatursverkningsgradÅtervinning) *
          ftxj5DriftfaktorDelfartProcent;

      const meddelande1KylaBrutto =
        kylbatteriSystemtyp === "Kyla saknas"
          ? 0
          : (ftxj5FlödeTilluftHelfart / 1000) * bimHandler.BIM_DensitetLuft * bimHandler.BIM_Luft_Energimängd * gradtimmarKylaUppmätt * ftxj5DriftfaktorHelfartProcent +
            (ftxj5FlödeTilluftHelfart / 1000) *
              ftxj5FlödeTilluftReduceradDrift *
              bimHandler.BIM_DensitetLuft *
              bimHandler.BIM_Luft_Energimängd *
              gradtimmarKylaUppmätt *
              ftxj5DriftfaktorDelfartProcent;

      const meddelande1VärmeNetto = meddelande1VärmeBrutto >= 1 ? meddelande1VärmeBrutto / vägledandeVerkningsgradVärme : 0;
      const meddelande1KylaNetto = meddelande1KylaBrutto >= 1 ? meddelande1KylaBrutto / vägledandeVerkningsgradKyla : 0;

      //Vilkor meddelande 2
      const meddelande2Vilkor1 = ftxj5börvärdeRegTilluft > 1 && ftxj5ärvärdeRegTilluft > 1;
      const meddelande2Vilkor2 = Math.abs(ftxj5ärvärdeRegTilluft - ftxj5börvärdeRegTilluft) > 1;
      const meddelande2Vilkor3 = ftxj5utstyrningEfterkylning >= 0.01;
      const meddelande2Vilkor4 = harBefuktning === "Nej" && harAvfuktare === "Nej";
      const meddelande2Vilkor = meddelande2Vilkor1 && meddelande2Vilkor4 && meddelande2Vilkor2;
      //värme
      //=((ftxj5ärvärdeRegTilluft-BIM_NormalårsTemperatur)*BIM_TimmarPerGrad_Värme)-((ftxj5börvärdeRegTilluft-BIM_NormalårsTemperatur)*BIM_TimmarPerGrad_Värme)
      const gradtimmarVärme =
        (ftxj5ärvärdeRegTilluft - bimHandler.normalårsTemperatur) * bimHandler.BIM_TimmarPerGrad_Värme -
        (ftxj5börvärdeRegTilluft - bimHandler.normalårsTemperatur) * bimHandler.BIM_TimmarPerGrad_Värme;
      //=((ftxj5FlödeTilluftHelfart/1000)*BIM_DensitetLuft*BIM_Luft_Energimängd*gradtimmarVärme*ftxj5DriftfaktorHelfartProcent)+(ftxj5FlödeTilluftHelfart/1000)*ftxj5FlödeTilluftReduceradDrift*BIM_DensitetLuft*BIM_Luft_Energimängd*gradtimmarVärme*ftxj5DriftfaktorDelfartProcent
      const kWhBruttoVärme =
        (ftxj5FlödeTilluftHelfart / 1000) *
          bimHandler.BIM_DensitetLuft *
          bimHandler.BIM_Luft_Energimängd *
          gradtimmarVärme *
          (1 - ftxj5UppmättTemperatursverkningsgradÅtervinning) *
          ftxj5DriftfaktorHelfartProcent +
        (ftxj5FlödeTilluftHelfart / 1000) *
          ftxj5FlödeTilluftReduceradDrift *
          bimHandler.BIM_DensitetLuft *
          bimHandler.BIM_Luft_Energimängd *
          gradtimmarVärme *
          (1 - ftxj5UppmättTemperatursverkningsgradÅtervinning) *
          ftxj5DriftfaktorDelfartProcent;
      const kWhNettoVärme = kWhBruttoVärme >= 1 ? kWhBruttoVärme / vägledandeVerkningsgradVärme : 0;
      //kyla
      //const gradtimmarKyla = gradtimmarKylaTabell1 - gradtimmarKylaTabell2;
      const gradtimmarKyla =
        (ftxj5börvärdeRegTilluft - bimHandler.normalårsTemperatur) * bimHandler.BIM_TimmarPerGrad_Värme -
        (ftxj5ärvärdeRegTilluft - bimHandler.normalårsTemperatur) * bimHandler.BIM_TimmarPerGrad_Värme;
      //=IF(kylbatteriSystemtyp=GIN_Kylbatteri_KylaSaknas;0;((ftxj5FlödeTilluftHelfart/1000)*BIM_DensitetLuft*BIM_Luft_Energimängd*R93*ftxj5DriftfaktorHelfartProcent)+((ftxj5FlödeTilluftHelfart/1000)*BIM_DensitetLuft*BIM_Luft_Energimängd*R93*ftxj5DriftfaktorDelfartProcent))
      const kWhBruttoKyla =
        kylbatteriSystemtyp === "Kyla saknas"
          ? 0
          : (ftxj5FlödeTilluftHelfart / 1000) * bimHandler.BIM_DensitetLuft * bimHandler.BIM_Luft_Energimängd * gradtimmarKyla * ftxj5DriftfaktorHelfartProcent +
            (ftxj5FlödeTilluftHelfart / 1000) * ftxj5FlödeTilluftReduceradDrift * bimHandler.BIM_DensitetLuft * bimHandler.BIM_Luft_Energimängd * gradtimmarKyla * ftxj5DriftfaktorDelfartProcent;
      const kWhNettoKyla = meddelande2Vilkor3 && kWhBruttoKyla >= 1 ? kWhBruttoKyla / vägledandeVerkningsgradKyla : 0;

      //Vilkor meddelande 3
      const meddelande3Vilkor1 = ftxj5börvärdeRegTilluft > 1;
      const meddelande3Vilkor2 = medelMätvärdeTilluftsdon > 1 && medelMätvärdeVistelse > 1;
      const meddelande3Vilkor3 = medelTempDiff <= 3;
      const meddelande3Vilkor4 = medelMätvärdeTilluftsdon >= 17;
      const meddelande3Vilkor5 = !kylaSaknas;
      const meddelande3Vilkor6 = medelMätvärdeVistelse >= 20;
      const meddelande3Vilkor7 = harAvfuktare === "Nej" && harBefuktning === "Nej";
      const meddelande3Vilkor = meddelande3Vilkor1 && meddelande3Vilkor2 && meddelande3Vilkor4 && meddelande3Vilkor6 && meddelande3Vilkor7;

      //Värme
      const minTilluftsTemp = 16;
      const optimalTilluftsTemp = medelMätvärdeVistelse - 4 > minTilluftsTemp ? medelMätvärdeVistelse - 4 : minTilluftsTemp;
      //=((ftxj5FlödeTilluftHelfart/1000)*BIM_DensitetLuft*BIM_Luft_Energimängd*ftxj5GradtimmarVärmeFörOrten*(1-ftxj5UppmättTemperatursverkningsgradÅtervinning)*ftxj5DriftfaktorHelfartProcent)+
      //(ftxj5FlödeTilluftHelfart/1000)*ftxj5FlödeTilluftReduceradDrift*BIM_DensitetLuft*BIM_Luft_Energimängd*ftxj5GradtimmarVärmeFörOrten*(1-ftxj5UppmättTemperatursverkningsgradÅtervinning)*ftxj5DriftfaktorDelfartProcent
      const värmeEnergiAktuellTemp =
        (ftxj5FlödeTilluftHelfart / 1000) *
          bimHandler.BIM_DensitetLuft *
          bimHandler.BIM_Luft_Energimängd *
          ftxj5GradtimmarVärmeFörOrten *
          (1 - ftxj5UppmättTemperatursverkningsgradÅtervinning) *
          ftxj5DriftfaktorHelfartProcent +
        (ftxj5FlödeTilluftHelfart / 1000) *
          ftxj5FlödeTilluftReduceradDrift *
          bimHandler.BIM_DensitetLuft *
          bimHandler.BIM_Luft_Energimängd *
          ftxj5GradtimmarVärmeFörOrten *
          (1 - ftxj5UppmättTemperatursverkningsgradÅtervinning) *
          ftxj5DriftfaktorDelfartProcent;
      const värmeGradtimmarOptimerad = (optimalTilluftsTemp - bimHandler.normalårsTemperatur) * bimHandler.BIM_TimmarPerGrad_Värme;

      //=((ftxj5FlödeTilluftHelfart/1000)*BIM_DensitetLuft*BIM_Luft_Energimängd*$N$110*(1-ftxj5UppmättTemperatursverkningsgradÅtervinning)*ftxj5DriftfaktorHelfartProcent)+
      //(ftxj5FlödeTilluftHelfart/1000)*ftxj5FlödeTilluftReduceradDrift*BIM_DensitetLuft*BIM_Luft_Energimängd*$N$110*(1-ftxj5UppmättTemperatursverkningsgradÅtervinning)*ftxj5DriftfaktorDelfartProcent
      // $N$110 = värmeGradtimmarOptimerad
      const värmeEnergiOptimeradTemp =
        (ftxj5FlödeTilluftHelfart / 1000) *
          bimHandler.BIM_DensitetLuft *
          bimHandler.BIM_Luft_Energimängd *
          värmeGradtimmarOptimerad *
          (1 - ftxj5UppmättTemperatursverkningsgradÅtervinning) *
          ftxj5DriftfaktorHelfartProcent +
        (ftxj5FlödeTilluftHelfart / 1000) *
          ftxj5FlödeTilluftReduceradDrift *
          bimHandler.BIM_DensitetLuft *
          bimHandler.BIM_Luft_Energimängd *
          värmeGradtimmarOptimerad *
          (1 - ftxj5UppmättTemperatursverkningsgradÅtervinning) *
          ftxj5DriftfaktorDelfartProcent;

      const meddelande3VärmeNetto = (värmeEnergiAktuellTemp - värmeEnergiOptimeradTemp) / vägledandeVerkningsgradVärme;

      //Besparingspotential värme
      const värmeNyttBörvärde = (formData?.nyttBörVärdeTilluft as number) || 0; //hämta från användare

      const värmeNyttGradtimmar = (värmeNyttBörvärde - bimHandler.normalårsTemperatur) * bimHandler.BIM_TimmarPerGrad_Värme;
      //=((ftxj5FlödeTilluftHelfart/1000)*BIM_DensitetLuft*BIM_Luft_Energimängd*$R$110*(1-ftxj5UppmättTemperatursverkningsgradÅtervinning)*ftxj5DriftfaktorHelfartProcent)+
      //(ftxj5FlödeTilluftHelfart/1000)*ftxj5FlödeTilluftReduceradDrift*BIM_DensitetLuft*BIM_Luft_Energimängd*ftxj5GradtimmarVärmeFörOrten*(1-ftxj5UppmättTemperatursverkningsgradÅtervinning)*ftxj5DriftfaktorDelfartProcent
      // $R$110 = värmeNyttGradtimmar
      const värmeNyttEnergi =
        (ftxj5FlödeTilluftHelfart / 1000) *
          bimHandler.BIM_DensitetLuft *
          bimHandler.BIM_Luft_Energimängd *
          värmeNyttGradtimmar *
          (1 - ftxj5UppmättTemperatursverkningsgradÅtervinning) *
          ftxj5DriftfaktorHelfartProcent +
        (ftxj5FlödeTilluftHelfart / 1000) *
          ftxj5FlödeTilluftReduceradDrift *
          bimHandler.BIM_DensitetLuft *
          bimHandler.BIM_Luft_Energimängd *
          ftxj5GradtimmarVärmeFörOrten *
          (1 - ftxj5UppmättTemperatursverkningsgradÅtervinning) *
          ftxj5DriftfaktorDelfartProcent;
      const meddelande3VärmeBesparingspotential = (värmeEnergiAktuellTemp - värmeNyttEnergi) / vägledandeVerkningsgradVärme;
      //----------

      //Kyla
      //=IF(kylbatteriSystemtyp=GIN_Kylbatteri_KylaSaknas;0;
      //((ftxj5FlödeTilluftHelfart/1000)*BIM_DensitetLuft*BIM_Luft_Energimängd*ftxj5GradtimmarKylaFörOrten*ftxj5DriftfaktorHelfartProcent)+
      //((ftxj5FlödeTilluftHelfart/1000)*BIM_DensitetLuft*BIM_Luft_Energimängd*ftxj5GradtimmarKylaFörOrten*ftxj5DriftfaktorDelfartProcent))
      const kylaEnergiAktuellTemp =
        kylbatteriSystemtyp === "Kyla saknas"
          ? 0
          : (ftxj5FlödeTilluftHelfart / 1000) * bimHandler.BIM_DensitetLuft * bimHandler.BIM_Luft_Energimängd * ftxj5GradtimmarKylaFörOrten * ftxj5DriftfaktorHelfartProcent +
            (ftxj5FlödeTilluftHelfart / 1000) * bimHandler.BIM_DensitetLuft * bimHandler.BIM_Luft_Energimängd * ftxj5GradtimmarKylaFörOrten * ftxj5DriftfaktorDelfartProcent;

      const gradtimmarKylaTabell3 = GetGradtimmarKyla(optimalTilluftsTemp);
      const kylaGradtimmarOptimerad = gradtimmarKylaTabell3;
      //=IF(kylbatteriSystemtyp=GIN_Kylbatteri_KylaSaknas;0;
      //((ftxj5FlödeTilluftHelfart/1000)*BIM_DensitetLuft*BIM_Luft_Energimängd*$N$116*ftxj5DriftfaktorHelfartProcent)+
      //((ftxj5FlödeTilluftHelfart/1000)*BIM_DensitetLuft*BIM_Luft_Energimängd*$N$116*ftxj5DriftfaktorDelfartProcent))
      //$N$116 : =kylaGradtimmarOptimerad
      const kylaEnergiOptimalTemp =
        kylbatteriSystemtyp === "Kyla saknas"
          ? 0
          : (ftxj5FlödeTilluftHelfart / 1000) * bimHandler.BIM_DensitetLuft * bimHandler.BIM_Luft_Energimängd * kylaGradtimmarOptimerad * ftxj5DriftfaktorHelfartProcent +
            (ftxj5FlödeTilluftHelfart / 1000) * bimHandler.BIM_DensitetLuft * bimHandler.BIM_Luft_Energimängd * kylaGradtimmarOptimerad * ftxj5DriftfaktorDelfartProcent;
      //=IF(AND($N$114<=0;$N$115<=0);0;($N$114-$N$115)/$B$64)
      const meddelande3KylaNetto = kylaEnergiAktuellTemp <= 0 && kylaEnergiOptimalTemp <= 0 ? 0 : (kylaEnergiAktuellTemp - kylaEnergiOptimalTemp) / vägledandeVerkningsgradKyla;

      //Besparingspotential kyla
      const gradtimmarKylaTabell4 = GetGradtimmarKyla(värmeNyttBörvärde);
      const kylaNyttGradtimmar = gradtimmarKylaTabell4;
      //=IF(kylbatteriSystemtyp=GIN_Kylbatteri_KylaSaknas;0;
      //((ftxj5FlödeTilluftHelfart/1000)*BIM_DensitetLuft*BIM_Luft_Energimängd*$R$115*ftxj5DriftfaktorHelfartProcent)+
      //((ftxj5FlödeTilluftHelfart/1000)*BIM_DensitetLuft*BIM_Luft_Energimängd*$R$115*ftxj5DriftfaktorDelfartProcent))
      //$R$115 : =kylaNyttGradtimmar
      const kylaNyttEnergi =
        kylbatteriSystemtyp === "Kyla saknas"
          ? 0
          : (ftxj5FlödeTilluftHelfart / 1000) * bimHandler.BIM_DensitetLuft * bimHandler.BIM_Luft_Energimängd * kylaNyttGradtimmar * ftxj5DriftfaktorHelfartProcent +
            (ftxj5FlödeTilluftHelfart / 1000) * bimHandler.BIM_DensitetLuft * bimHandler.BIM_Luft_Energimängd * kylaNyttGradtimmar * ftxj5DriftfaktorDelfartProcent;
      //=IF(AND($N$114<=0;$R$116<=0);0;($N$114-$R$116)/$B$64)
      const meddelande3KylaBesparingspotential = kylaEnergiAktuellTemp <= 0 && kylaNyttEnergi <= 0 ? 0 : (kylaEnergiAktuellTemp - kylaNyttEnergi) / vägledandeVerkningsgradKyla;

      //Vilkor meddelande 4o5
      const meddelande4o5Vilkor1 = ftxj5tempUteluft <= 30 && ftxj5tempUteluft >= -30;
      const meddelande4o5Vilkor2 = ftxj5tempTillLuftEfterÅtervinningsBat <= 30 && ftxj5tempTillLuftEfterÅtervinningsBat >= -30;
      const meddelande4o5Vilkor3 = ftxj5tempTillLuftEfterEftervärmningssBat <= 30 && ftxj5tempTillLuftEfterEftervärmningssBat >= -30;
      const meddelande4o5Vilkor4 = ftxj5tempTillLuftEfterEfterkylningssBat <= 30 && ftxj5tempTillLuftEfterEfterkylningssBat >= -30;
      const meddelande4o5Vilkor5 = ftxj5kontrollmättTempRegTilluft <= 30 && ftxj5kontrollmättTempRegTilluft >= -30;
      const meddelande4o5Vilkor6 = ftxj5börvärdeRegTilluft > 1;
      const meddelande4o5Vilkor7 = !kylaSaknas;
      const meddelande4o5Vilkor14 = ftxj5tempFrånLuftInnanÅtervinningsBat < ftxj5tempUteluft;
      const meddelande4o5Vilkor8 = kylÅtervinningAktiv === "Ja" && meddelande4o5Vilkor14;
      const meddelande4o5Vilkor9 = ftxj5utstyrningVärmeåtervinning <= 0.99;
      const meddelande4o5Vilkor10 = ftxj5utstyrningVärmeåtervinning >= 0.009;
      const meddelande4o5Vilkor11 = ftxj5utstyrningEftervärmning <= 0;
      const meddelande4o5Vilkor12 = meddelande4o5Vilkor10 || !meddelande4o5Vilkor11;
      const meddelande4o5Vilkor13 = ftxj5utstyrningEfterkylning <= 0;
      const meddelande4o5Vilkor15 = ftxj5EnergiÅtervinningsbatterikWh + ftxj5EnergiEftervärmningsbatterikWh <= ftxj5NormalEnergianvändningVärmeKwhÅr;
      const meddelande4o5Vilkor16 = ftxj5EnergiÅtervinningsbatterikWh + ftxj5EnergiEftervärmningsbatterikWh > ftxj5NormalEnergianvändningVärmeKwhÅr;

      const ftxJ5meddelande4o5Överkonsumption1 = meddelande4o5Vilkor15 ? ftxj5EnergiEftervärmningsbatterikWh : 0;

      //=IF(IsFTX;
      //IF(ftxJ5meddelande4o5Vilkor16=1;ftxj5EnergiÅtervinningsbatterikWh+ftxj5EnergiEftervärmningsbatterikWh-ftxj5NormalEnergianvändningVärmeKwhÅr;0);
      //IF(ftxJ5meddelande4o5Vilkor16=1;ftxj5EnergiEftervärmningsbatterikWh-ftxj5NormalEnergianvändningVärmeKwhÅr;0))
      const ftxJ5meddelande4o5Överkonsumption2 = isFTX
        ? meddelande4o5Vilkor16
          ? ftxj5EnergiÅtervinningsbatterikWh + ftxj5EnergiEftervärmningsbatterikWh - ftxj5NormalEnergianvändningVärmeKwhÅr
          : 0
        : meddelande4o5Vilkor16
          ? ftxj5EnergiEftervärmningsbatterikWh - ftxj5NormalEnergianvändningVärmeKwhÅr
          : 0;

      const ftxJ5meddelande4o5ÖverkonsumptionMax = Math.max(ftxJ5meddelande4o5Överkonsumption1, ftxJ5meddelande4o5Överkonsumption2);

      //kWa och energislag
      const energiSlagVärme = globalData.Byggnadsdata.Värmekälla.find((s) => s.Värmekälla === byggnadModuleData.energikälla)?.Energislag as string;
      const energiSlagKyla = globalData.Ventilation.Kylform.find((s) => s.Kylform === kylform)?.Energiform as string;

      const tempDiffUppmättMotÄrvärde = Math.abs(ftxj5kontrollmättTempRegTilluft - ftxj5ärvärdeRegTilluft);
      const ftxj5Meddelande1kWh1 = tempDiffUppmättMotÄrvärde < 1 ? 0 : meddelande1VärmeNetto;
      const ftxj5Meddelande1kWh2 = tempDiffUppmättMotÄrvärde < 1 ? 0 : meddelande1KylaNetto;

      const tempDiffÄrvärdeMotBörvärde = Math.abs(ftxj5ärvärdeRegTilluft - ftxj5börvärdeRegTilluft);
      const ftxj5Meddelande2kWh1 = tempDiffÄrvärdeMotBörvärde < 1 || meddelande4o5Vilkor11 ? 0 : kWhNettoVärme;
      const ftxj5Meddelande2kWh2 = tempDiffÄrvärdeMotBörvärde < 1 || meddelande4o5Vilkor13 ? 0 : kWhNettoKyla;

      const tempDiffAktuellMotOptimal = Math.abs(optimalTilluftsTemp - ftxj5börvärdeRegTilluft);
      //=IF(tempDiffAktuellMotOptimal>0,5;'Grunddata IN'!E4="Rondering vinter");N111;0)
      const ftxj5Meddelande3kWh1 = tempDiffAktuellMotOptimal >= 0.5 && !isSummer ? meddelande3VärmeNetto : 0;
      //=IF(tempDiffAktuellMotOptimal>0,5;'Grunddata IN'!E4="Rondering sommar");N117;0)
      const ftxj5Meddelande3kWh2 = tempDiffAktuellMotOptimal >= 0.5 && isSummer ? meddelande3KylaNetto : 0;
      //50 : =IF(AND(ftxj5meddelande3VärmeBesparingspotential>=300;'Grunddata IN'!E4="Rondering vinter");ftxj5meddelande3VärmeBesparingspotential;0)
      const ftxj5Meddelande3kWh3 = meddelande3VärmeBesparingspotential >= 0 && !isSummer ? meddelande3VärmeBesparingspotential : 0;
      //J51 : =IF(AND(ftxj5meddelande3KylaBesparingspotential>=300;'Grunddata IN'!E4="Rondering sommar");ftxj5meddelande3KylaBesparingspotential;0)
      const ftxj5Meddelande3kWh4 = meddelande3KylaBesparingspotential >= 0 && isSummer ? meddelande3KylaBesparingspotential : 0;
      //J52 : =IF(AND(ftxj5meddelande3VärmeBesparingspotential<=-300;'Grunddata IN'!E4="Rondering vinter");ABS(ftxj5meddelande3VärmeBesparingspotential);0)
      const ftxj5Meddelande3kWh5 = meddelande3VärmeBesparingspotential < 0 && !isSummer ? Math.abs(meddelande3VärmeBesparingspotential) : 0;
      //J53 : =IF(AND(ftxj5meddelande3KylaBesparingspotential<=-300;'Grunddata IN'!E4="Rondering sommar");ABS(ftxj5meddelande3KylaBesparingspotential);0)
      const ftxj5Meddelande3kWh6 = meddelande3KylaBesparingspotential <= 0 && isSummer ? Math.abs(meddelande3KylaBesparingspotential) : 0;

      //
      //=IF(AND(ftxj5EnergiEftervärmningsbatterikWh>0;ftxJ5meddelande4o5Vilkor9=1;ftxJ5meddelande4o5Vilkor11=0;ftxJ5meddelande4o5Vilkor13=1);ftxJ5meddelande4o5ÖverkonsumptionMax;0)

      const ftxj5Meddelande4kWh1 =
        ftxj5EnergiEftervärmningsbatterikWh > 0 && meddelande4o5Vilkor9 && !meddelande4o5Vilkor11 && meddelande4o5Vilkor13 ? ftxJ5meddelande4o5ÖverkonsumptionMax / vägledandeVerkningsgradVärme : 0;
      //=IF(AND(ftxj5EnergiEfterkylningsbatterikWh>0;ftxJ5meddelande4o5Vilkor10=1;ftxJ5meddelande4o5Vilkor13=0;ftxJ5meddelande4o5Vilkor11=1;ftxJ5meddelande4o5Vilkor8=0);(ftxj5EnergiEfterkylningsbatterikWh-ftxj5NormalEnergianvändningKylaKwhÅr)/ftxj5vägledandeVerkningsgradKyla;0)
      const ftxj5Meddelande4kWh2 =
        ftxj5EnergiEfterkylningsbatterikWh > 0 && meddelande4o5Vilkor10 && !meddelande4o5Vilkor13 && meddelande4o5Vilkor11 && !meddelande4o5Vilkor8
          ? (ftxj5EnergiEfterkylningsbatterikWh - ftxj5NormalEnergianvändningKylaKwhÅr) / vägledandeVerkningsgradKyla
          : 0;
      //=IF(AND(ftxj5EnergiEfterkylningsbatterikWh>0;ftxJ5meddelande4o5Vilkor11=0;ftxJ5meddelande4o5Vilkor13=0;ftxJ5meddelande4o5Vilkor10=0);(ftxj5EnergiEfterkylningsbatterikWh-ftxj5NormalEnergianvändningKylaKwhÅr)/ftxvägledandeVerkningsgradVärme;0)
      const ftxj5Meddelande4kWh3 =
        ftxj5EnergiEfterkylningsbatterikWh > 0 && !meddelande4o5Vilkor11 && !meddelande4o5Vilkor13 && !meddelande4o5Vilkor10
          ? (ftxj5EnergiEfterkylningsbatterikWh - ftxj5NormalEnergianvändningKylaKwhÅr) / vägledandeVerkningsgradVärme
          : 0;
      //=IF(AND(ftxj5EnergiEfterkylningsbatterikWh>0;ftxJ5meddelande4o5Vilkor11=0;ftxJ5meddelande4o5Vilkor13=0;ftxJ5meddelande4o5Vilkor10=0);(ftxj5EnergiEfterkylningsbatterikWh-ftxj5NormalEnergianvändningKylaKwhÅr)/ftxj5vägledandeVerkningsgradKyla;0)
      const ftxj5Meddelande4kWh4 =
        ftxj5EnergiEfterkylningsbatterikWh > 0 && !meddelande4o5Vilkor11 && !meddelande4o5Vilkor13 && !meddelande4o5Vilkor10
          ? (ftxj5EnergiEfterkylningsbatterikWh - ftxj5NormalEnergianvändningKylaKwhÅr) / vägledandeVerkningsgradKyla
          : 0;
      //=IF(AND(ftxj5EnergiEfterkylningsbatterikWh>0;ftxJ5meddelande4o5Vilkor11=0;ftxJ5meddelande4o5Vilkor13=0;ftxJ5meddelande4o5Vilkor10=1);(ftxj5EnergiEfterkylningsbatterikWh-ftxj5NormalEnergianvändningKylaKwhÅr)/ftxvägledandeVerkningsgradVärme;0)
      const ftxj5Meddelande4kWh5 =
        ftxj5EnergiEfterkylningsbatterikWh > 0 && !meddelande4o5Vilkor11 && !meddelande4o5Vilkor13 && meddelande4o5Vilkor10
          ? (ftxj5EnergiEfterkylningsbatterikWh - ftxj5NormalEnergianvändningKylaKwhÅr) / vägledandeVerkningsgradVärme
          : 0;
      //=IF(AND(ftxj5EnergiEfterkylningsbatterikWh>0;ftxJ5meddelande4o5Vilkor11=0;ftxJ5meddelande4o5Vilkor13=0;ftxJ5meddelande4o5Vilkor10=1);(ftxj5EnergiEfterkylningsbatterikWh-ftxj5NormalEnergianvändningKylaKwhÅr)/ftxj5vägledandeVerkningsgradKyla;0)
      const ftxj5Meddelande4kWh6 =
        ftxj5EnergiEfterkylningsbatterikWh > 0 && !meddelande4o5Vilkor11 && !meddelande4o5Vilkor13 && meddelande4o5Vilkor10
          ? (ftxj5EnergiEfterkylningsbatterikWh - ftxj5NormalEnergianvändningKylaKwhÅr) / vägledandeVerkningsgradKyla
          : 0;
      //=IF(IsFTX;
      // IF(AND(ftxj5EnergiEftervärmningsbatterikWh>0;ftxJ5meddelande4o5Vilkor9=1;ftxJ5meddelande4o5Vilkor10=1;ftxJ5meddelande4o5Vilkor11=1;ftxJ5meddelande4o5Vilkor13=1);ftxJ5meddelande4o5ÖverkonsumptionMax;0);
      // IF(AND(ftxj5EnergiEftervärmningsbatterikWh>0;ftxJ5meddelande4o5Vilkor11=1);ftxJ5meddelande4o5ÖverkonsumptionMax;0))

      const ftxj5Meddelande5kWh1 = isFTX
        ? ftxj5EnergiEftervärmningsbatterikWh > 0 && meddelande4o5Vilkor9 && meddelande4o5Vilkor11
          ? ftxJ5meddelande4o5ÖverkonsumptionMax / vägledandeVerkningsgradVärme
          : 0
        : ftxj5EnergiEftervärmningsbatterikWh > 0 && meddelande4o5Vilkor11
          ? ftxJ5meddelande4o5ÖverkonsumptionMax / vägledandeVerkningsgradVärme
          : 0;

      //=IF(AND(ftxj5EnergiEftervärmningsbatterikWh>0;ftxj5EnergiEfterkylningsbatterikWh>0;ftxJ5meddelande4o5Vilkor10=0;ftxJ5meddelande4o5Vilkor11=1;ftxJ5meddelande4o5Vilkor13=0);(ftxj5EnergiEfterkylningsbatterikWh-ftxj5NormalEnergianvändningKylaKwhÅr)/ftxj5vägledandeVerkningsgradKyla;0)
      const ftxj5Meddelande5kWh2 =
        ftxj5EnergiEftervärmningsbatterikWh > 0 && ftxj5EnergiEfterkylningsbatterikWh > 0 && meddelande4o5Vilkor11
          ? (ftxj5EnergiEfterkylningsbatterikWh - ftxj5NormalEnergianvändningKylaKwhÅr) / vägledandeVerkningsgradKyla
          : 0;

      //=IF(AND(ftxj5EnergiEfterkylningsbatterikWh>0;ftxJ5meddelande4o5Vilkor12=1;ftxJ5meddelande4o5Vilkor13=1);(ftxj5EnergiEfterkylningsbatterikWh)/ftxvägledandeVerkningsgradVärme;0)
      const ftxj5Meddelande5kWh3 = ftxj5EnergiEfterkylningsbatterikWh > 0 && meddelande4o5Vilkor12 && meddelande4o5Vilkor13 ? ftxj5EnergiEftervärmningsbatterikWh / vägledandeVerkningsgradVärme : 0;
      //=IF(AND($B$61="Ja";ftxj5EnergiEfterkylningsbatterikWh>0;ftxJ5meddelande4o5Vilkor12=1;ftxJ5meddelande4o5Vilkor13=1);(ftxj5EnergiEfterkylningsbatterikWh-ftxj5NormalEnergianvändningKylaKwhÅr)/ftxj5vägledandeVerkningsgradKyla;0)
      const ftxj5Meddelande5kWh4 =
        !kylaSaknas && ftxj5EnergiEfterkylningsbatterikWh > 0 && meddelande4o5Vilkor13 ? (ftxj5EnergiEfterkylningsbatterikWh - ftxj5NormalEnergianvändningKylaKwhÅr) / vägledandeVerkningsgradKyla : 0;
      //=IF(AND(ftxj5EnergiEfterkylningsbatterikWh>0;ftxj5EnergiÅtervinningsbatterikWh>0;ftxJ5meddelande4o5Vilkor10=0;ftxJ5meddelande4o5Vilkor11=1;ftxJ5meddelande4o5Vilkor13=0);(ftxj5EnergiEfterkylningsbatterikWh-ftxj5NormalEnergianvändningKylaKwhÅr)/ftxj5vägledandeVerkningsgradKyla;0)
      const ftxj5Meddelande5kWh5 =
        ftxj5EnergiEfterkylningsbatterikWh > 0 && ftxj5EnergiÅtervinningsbatterikWh > 0 && !meddelande4o5Vilkor10 && meddelande4o5Vilkor11 && !meddelande4o5Vilkor13
          ? (ftxj5EnergiEfterkylningsbatterikWh - ftxj5NormalEnergianvändningKylaKwhÅr) / vägledandeVerkningsgradKyla
          : 0;

      debug["Tabeller"] = {
        gradtimmarKylaTabell1,
        gradtimmarKylaTabell2,
        gradtimmarKylaTabell3,
        gradtimmarKylaTabell4,
        medelMätvärdeVistelse,
        medelMätvärdeTilluftsdon,
        medelTempDiff,
      };

      debug["Meddelande 1"] = {
        meddelande1Vilkor1,
        meddelande1Vilkor2,
        meddelande1Vilkor3,
        meddelande1Vilkor,
        gradtimmarVärmeUppmätt,
        gradtimmarKylaUppmätt,
        meddelande1Netto: meddelande1VärmeNetto,
      };

      debug["Meddelande 2"] = {
        meddelande2Vilkor1,
        meddelande2Vilkor2,
        meddelande2Vilkor3,
        meddelande2Vilkor4,
        meddelande2Vilkor,
        gradtimmarVärme,
        kWhBruttoVärme,
        kWhNettoVärme,
        gradtimmarKyla,
        kWhBruttoKyla,
        kWhNettoKyla,
      };

      debug["Meddelande 3"] = {
        meddelande3Vilkor1,
        meddelande3Vilkor2,
        meddelande3Vilkor3,
        meddelande3Vilkor4,
        meddelande3Vilkor5,
        meddelande3Vilkor6,
        meddelande3Vilkor7,
        meddelande3Vilkor,
        tempDiffAktuellMotOptimal,
        optimalTilluftsTemp,
        värmeEnergiAktuellTemp,
        värmeEnergiOptimeradTemp,
        värmeGradtimmarOptimerad,
        meddelande3VärmeNetto,
        värmeNyttBörvärde,
        värmeNyttGradtimmar,
        värmeNyttEnergi,
        meddelande3VärmeBesparingspotential,
        kylaEnergiAktuellTemp,
        kylaEnergiOptimalTemp,
        kylaGradtimmarOptimerad,
        meddelande3KylaNetto,
        kylaNyttGradtimmar,
        kylaNyttEnergi,
        meddelande3KylaBesparingspotential,
      };

      debug["Meddelande 4o5"] = {
        meddelande4o5Vilkor1,
        meddelande4o5Vilkor2,
        meddelande4o5Vilkor3,
        meddelande4o5Vilkor4,
        meddelande4o5Vilkor5,
        meddelande4o5Vilkor6,
        meddelande4o5Vilkor7,
        meddelande4o5Vilkor8,
        meddelande4o5Vilkor9,
        meddelande4o5Vilkor10,
        meddelande4o5Vilkor11,
        meddelande4o5Vilkor12,
        meddelande4o5Vilkor13,
        meddelande4o5Vilkor14,
        meddelande4o5Vilkor15,
        meddelande4o5Vilkor16,
        ftxJ5meddelande4o5Överkonsumption1,
        ftxJ5meddelande4o5Överkonsumption2,
        ftxJ5meddelande4o5ÖverkonsumptionMax,
      };

      debug["kWa och energislag"] = {
        energiSlagVärme,
        energiSlagKyla,
        ftxj5Meddelande1kWh1,
        ftxj5Meddelande2kWh1,
        ftxj5Meddelande2kWh2,
        ftxj5Meddelande3kWh1,
        ftxj5Meddelande3kWh2,
        ftxj5Meddelande3kWh3,
        ftxj5Meddelande3kWh4,
        ftxj5Meddelande3kWh5,
        ftxj5Meddelande3kWh6,
        ftxj5Meddelande4kWh1,
        ftxj5Meddelande4kWh2,
        ftxj5Meddelande4kWh3,
        ftxj5Meddelande4kWh4,
        ftxj5Meddelande4kWh5,
        ftxj5Meddelande4kWh6,
        ftxj5Meddelande5kWh1,
        ftxj5Meddelande5kWh2,
        ftxj5Meddelande5kWh3,
        ftxj5Meddelande5kWh4,
        ftxj5Meddelande5kWh5,
      };

      debug["Energi per sekvens luftbehandling"] = {
        ftxj5EnergiÅtervinningsbatterikWh,
        ftxj5EnergiEftervärmningsbatterikWh,
        ftxj5EnergiEfterkylningsbatterikWh,
        ftxj5EnergiÅtervinningsbatteriGradtimmar,
        ftxj5EnergiEftervärmningsbatteriGradtimmar,
        ftxj5EnergiEfterkylningsbatteriGradtimmar,
      };

      data.export.optimalTilluftsTemp = optimalTilluftsTemp;
      data.export.aktuellTilluftsTemp = ftxj5börvärdeRegTilluft;
      data.export.driftOptimeringAktiv = meddelande3Vilkor;

      if (moduleData.ärHuvudsakligtVärmesystem === "Ja") data.export.temperaturInfo = bimHandler.getModuleTemperatureInfo(module.name);
      else data.export.temperaturInfo = undefined;

      //Funktionskontroller
      //Funktionskontroll 1
      if (meddelande1Vilkor && (ftxj5Meddelande1kWh1 > 0 || ftxj5Meddelande1kWh2 > 0)) {
        if (ftxj5Meddelande1kWh1 > 0) {
          funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 1, ftxj5Meddelande1kWh1, energiSlagVärme, { variant: "a1" }));
        }
        if (ftxj5Meddelande1kWh2 > 0) {
          funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 1, ftxj5Meddelande1kWh2, energiSlagKyla, { variant: "a1" }));
        }
      } else {
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 1, undefined, "", { variant: "b" }));
      }

      //Funktionskontroll 2
      if (meddelande2Vilkor && (ftxj5Meddelande2kWh1 > 0 || ftxj5Meddelande2kWh2 > 0)) {
        if (ftxj5Meddelande2kWh1 > 0) {
          funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 2, ftxj5Meddelande2kWh1, energiSlagVärme, { variant: "a1" }));
        }
        if (ftxj5Meddelande2kWh2 > 0) {
          funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 2, ftxj5Meddelande2kWh2, energiSlagKyla, { variant: "a1" }));
        }
      } else {
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 2, undefined, "", { variant: "b" }));
      }

      //Funktionskontroll 4
      let funktionskontroll4Used = false;
      if (ftxj5Meddelande4kWh1 > 300 && isFTX) {
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 4, ftxj5Meddelande4kWh1, energiSlagVärme, { variant: "a1" }));

        funktionskontroll4Used = true;
      }
      if (ftxj5Meddelande4kWh2 > 300 && isFTX) {
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 4, ftxj5Meddelande4kWh2, energiSlagKyla, { variant: "a2" }));

        funktionskontroll4Used = true;
      }
      if (ftxj5Meddelande4kWh3 > 300) {
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 4, ftxj5Meddelande4kWh3, energiSlagVärme, { variant: "a3" }));

        funktionskontroll4Used = true;
      }
      if (ftxj5Meddelande4kWh4 > 300) {
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 4, ftxj5Meddelande4kWh4, energiSlagKyla, { variant: "a3" }));

        funktionskontroll4Used = true;
      }
      if (ftxj5Meddelande4kWh5 > 300 && isFTX) {
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 4, ftxj5Meddelande4kWh5, energiSlagVärme, { variant: "a5" }));

        funktionskontroll4Used = true;
      }
      if (ftxj5Meddelande4kWh6 > 300 && isFTX) {
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 4, ftxj5Meddelande4kWh6 >= 300 ? ftxj5Meddelande4kWh6 : undefined, energiSlagKyla, { variant: "a5" }));

        funktionskontroll4Used = true;
      }
      if (!funktionskontroll4Used) {
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 4, undefined, "", { variant: "b" }));
      }

      //Funktionskontroll 5
      let funktionskontroll5Used = false;
      if (ftxj5Meddelande5kWh1 > 300) {
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 5, ftxj5Meddelande5kWh1, energiSlagVärme, { variant: "a1" }));

        funktionskontroll5Used = true;
      }
      if (ftxj5Meddelande5kWh2 > 300) {
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 5, ftxj5Meddelande5kWh2, energiSlagKyla, { variant: "a1" }));

        funktionskontroll5Used = true;
      }
      if (ftxj5Meddelande5kWh3 > 300) {
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 5, ftxj5Meddelande5kWh3, energiSlagVärme, { variant: "a3" }));

        funktionskontroll5Used = true;
      }
      if (ftxj5Meddelande5kWh4 > 300) {
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 5, ftxj5Meddelande5kWh4, energiSlagKyla, { variant: "a3" }));

        funktionskontroll5Used = true;
      }
      if (ftxj5Meddelande5kWh5 > 300 && isFTX) {
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 5, ftxj5Meddelande5kWh5, energiSlagKyla, { variant: "a5" }));

        funktionskontroll5Used = true;
      }
      if (!funktionskontroll5Used) {
        funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 5, undefined, "", { variant: "b" }));
      }

      //OptText3_a1 o a2 => funktionskontroll'
      if (moduleData.ärHuvudsakligtVärmesystem !== "Ja") {
        let funktionskontroll3Used = false;
        if (ftxj5Meddelande3kWh1 > 0) {
          funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 3, ftxj5Meddelande3kWh1, energiSlagVärme, { variant: "a1" }));
          funktionskontroll3Used = true;
        }
        if (ftxj5Meddelande3kWh2 > 0 && !kylaSaknas) {
          funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 3, ftxj5Meddelande3kWh2, energiSlagKyla, { variant: "a2" }));
          funktionskontroll3Used = true;
        }
        if (!funktionskontroll3Used) {
          funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 3, undefined, "", { variant: "b" }));
        }
      }

      //Driftoptimering 3
      if (meddelande3Vilkor && formData?.harAngettNyttVärdeTilluft === "Ja" && formData?.nyttBörVärdeTilluft !== undefined && !isNaN(formData?.nyttBörVärdeTilluft)) {
        const valAsNumber = Number(formData?.nyttBörVärdeTilluft);
        if (valAsNumber >= 15 && valAsNumber <= 35) {
          if (ftxj5Meddelande3kWh3 > 0) {
            driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 3, ftxj5Meddelande3kWh3, energiSlagVärme, { variant: "a3" }));
          }
          if (ftxj5Meddelande3kWh4 > 0 && !kylaSaknas) {
            driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 3, ftxj5Meddelande3kWh4, energiSlagKyla, { variant: "a3" }));
          }

          if (ftxj5Meddelande3kWh5 > 0) {
            driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 3, ftxj5Meddelande3kWh5, energiSlagVärme, { variant: "a5" }));
          }
          if (ftxj5Meddelande3kWh6 > 0 && !kylaSaknas) {
            driftOptimeringar.push(roundHandler.getDriftoptimering(bfName, 3, ftxj5Meddelande3kWh6, energiSlagKyla, { variant: "a5" }));
          }
        }
      } else {
        if (moduleData.ärHuvudsakligtVärmesystem !== "Ja") {
        }
      }
      return {
        bfName: BFLType.BFL_J5_FTX_FT,
        funktionsKontroller: bH.cleanFunktionsKontroller(funktionsKontroller),
        driftOptimeringar: bH.cleanDriftoptimeringar(driftOptimeringar),
        note: "",
        debug: debug,
        error: error,
        data: data,
      };
    } catch (ex: any) {
      return {
        bfName: BFLType.BFL_J5_FTX_FT,
        funktionsKontroller: [],
        driftOptimeringar: [],
        note: "",
        data: {},
        debug: { Error: ex },
        error: ex,
      };
    }
  };

  /// transfers any formdata values to the bf data.
  const bflSpecificPrepareData = (module: IModuleRound, bfl: IBFResult, bflForm: IBFResult | undefined) => {
    if (!bfl) return;
    if (bflForm?.data) {
      bfl.data = { ...bflForm.data };
    }
  };

  return { getResult, bflSpecificPrepareData, bfName };
};

const dflt = { bfl_J5_FTX_FT };

export default dflt;
